import dynamic from 'next/dynamic';
import { GetStaticProps } from 'next';

import client from '@utils/apolloClient';
import { getAboutItemBySlug } from '@queries/about.graphql';

import Article from '@components/Article/Article';
import Layout from '@components/Layout/Layout';
import Description from '@components/Description/Description';
import SecondaryTitle from '@components/SecondaryTitle/SecondaryTitle';

const ContactForm = dynamic(
  () => import('@components/ContactForm/ContactForm')
);

type AboutProps = {
  description: string;
  featureFlags: any;
  intro: string;
  quotes: any;
  siteTitle: string;
  title: string;
};

const About = ({
  description,
  featureFlags,
  intro,
  quotes,
  siteTitle,
  title,
}: AboutProps) => {
  return (
    <Layout
      featureFlags={featureFlags}
      pageTitle={title}
      pageType="article"
      section="Home"
      siteTitle={siteTitle}
      url="/about"
    >
      <Article.HeaderWrapper>
        <SecondaryTitle>{intro}</SecondaryTitle>
      </Article.HeaderWrapper>

      <Article.ContentWrapper>
        <Description content={description} />
      </Article.ContentWrapper>

      <Article.ContentWrapper>
        <br />
        <br />
        <br />
        <br />
        <br />
        <ContactForm />
      </Article.ContentWrapper>
    </Layout>
  );
};

export default About;

export const getStaticProps: GetStaticProps = async () => {
  const configData = await import(`../siteconfig.json`);

  const {
    data: { AboutItem: about },
  } = await client.query({
    query: getAboutItemBySlug,
    variables: {
      slug: 'about',
    },
  });

  return {
    props: {
      ...about.content,
      featureFlags: configData.featureFlags,
      siteTitle: configData.default.title,
    },
  };
};
